import Immutable from 'immutable';

import {dataResetPoints} from '../services/fluxes';
import {
  ADD_STEP,
  REMOVE_STEP,
  RESET_FLUX,
  UPDATE_FLUX_DATA
} from '../actions/fluxes';

const initialState = Immutable.fromJS({
  steps: Immutable.Stack(),
  data: {}
});

export default function(state = initialState, action) {
  let newState = state;

  switch (action.type) {
    case ADD_STEP:
      if (!action.step) {
        return state;
      }

      if (action.replace) {
        const latestStep = state.get('steps').first();
        if (latestStep && latestStep.has('location')) {
          newState = state.set(
            'steps',
            state.get('steps').withMutations(stack => {
              stack.shift().unshift(
                Immutable.fromJS({
                  location: action.replace
                })
              );
            })
          );
        }
      }

      return newState
        .set(
          'steps',
          newState.get('steps').unshift(
            Immutable.fromJS({
              location: action.step
            })
          )
        )
        .set(
          'data',
          newState.get('data').merge(Immutable.fromJS(action.data || {}))
        );
    case REMOVE_STEP:
      let steps = state.get('steps');
      if (steps.size === 0) {
        return state.set('data', Immutable.fromJS(action.data || {}));
      }

      newState = state.set('steps', state.get('steps').shift());
      steps = newState.get('steps');

      if (
        steps.size === 0 ||
        dataResetPoints.indexOf(steps.first().get('location')) !== -1
      ) {
        return newState.set('data', Immutable.Map());
      }

      return newState.set(
        'data',
        state.get('data').merge(Immutable.fromJS(action.data || {}))
      );
    case RESET_FLUX:
      return initialState;
    case UPDATE_FLUX_DATA:
      if (!action.data) {
        return state;
      }

      return state.set('data', Immutable.fromJS(action.data));
    default:
      return state;
  }
}

/* Selectors */

export function getSteps(state) {
  return state.getIn(['fluxes', 'steps']) || Immutable.Stack();
}

export function hasNoSteps(state) {
  return getSteps(state).size === 0;
}

export function getCurrentStep(state) {
  return getSteps(state).first() || Immutable.Map();
}

export function getFluxData(state) {
  return state.getIn(['fluxes', 'data']) || Immutable.Map();
}
